import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';

function StaticSvg({ largeSvg, smallSvg }) {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Container fluid className='container-section'>
      {/* Conditionally render the SVG based on screen size */}
      {isSmallScreen ? smallSvg : largeSvg}
    </Container>
  );
}

export default StaticSvg;
